import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface ChargePointsState {
    value: number
}

const initialState: ChargePointsState = {
    value: 0,
}

export const chargePointsSlice = createSlice({
    name: 'chargepoints',
    initialState,
    reducers: {
        increment: (state) => {
            state.value += 1
        },
        decrement: (state) => {
            state.value -= 1
        },
        incrementByAmount: (state, action: PayloadAction<number>) => {
            state.value += action.payload
        },
    },
})

export const { increment, decrement, incrementByAmount } = chargePointsSlice.actions

export default chargePointsSlice.reducer
